import React from "react";
import darkLogoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import { useTranslation } from "react-i18next";

import { CautionIcon } from "~/assets/svg/InterfaceIcon";

const ServiceIntro = ({ portfolio }) => {
	const { t } = useTranslation();

	return (
		<li className="detail-info-item">
			<h4 className="detail-info-title">
				{t("pages.portfolio.PortfolioView.components.ServiceIntro.intro")}
			</h4>
			{/* <div className="c__noData">
        <CautionIcon />
        <p className="main">서비스 소개를 작성해주세요.</p>
      </div> */}
			{portfolio?.StartupProduct?.length <= 0 && (
				<div className="c__noData">
					<CautionIcon />
					<p className="main">
						{t("pages.portfolio.PortfolioView.components.ServiceIntro.inputIntro")}
					</p>
				</div>
			)}
			{portfolio?.StartupProduct?.map((product) => {
				return (
					<div key={product.idx} className="service-intro">
						<dl className="company-data">
							<dt>{product.title}</dt>
							<dd>{product.seed}</dd>
						</dl>
						<p className="company-explain">{product.description}</p>
						<ul className="c__tag-wrap">
							{product.Keyword.map((keyword) => {
								return (
									<li key={keyword.idx} className="c__tag-view">
										{keyword.title}
									</li>
								);
							})}
							{/* <li className="c__tag-view">환경</li> */}
						</ul>
						<ul className="product-group">
							{product.Image.map((image) => {
								return (
									<li key={image.idx} className="product-img">
										<a href={image.imgUrl} target="_blank" rel="noreferrer">
											<img
												src={image.imgUrl || darkLogoImg}
												alt={t(
													"pages.portfolio.PortfolioView.components.ServiceIntro.img"
												)}
											/>
										</a>
									</li>
								);
							})}
							{/* <li className="product-img">
                  <img src={darkLogoImg} alt="서비스소개이미지" />
                </li> */}
						</ul>
					</div>
				);
			})}
			{/* <div className="service-intro">
        <dl className="company-data">
          <dt>service1</dt>
          <dd>양산/상용화단계</dd>
        </dl>
        <p className="company-explain">service1에 대한 제품설명</p>
        <ul className="c__tag-wrap">
          <li className="c__tag-view">블록체인</li>
          <li className="c__tag-view">환경</li>
        </ul>
        <ul className="product-group">
          <li className="product-img">
            <img src={darkLogoImg} alt="서비스소개이미지" />
          </li>
          <li className="product-img">
            <img src={darkLogoImg} alt="서비스소개이미지" />
          </li>
        </ul>
      </div>
      <div className="service-intro">
        <dl className="company-data">
          <dt>service1</dt>
          <dd>양산/상용화단계</dd>
        </dl>
        <p className="company-explain">service1에 대한 제품설명</p>
        <ul className="c__tag-wrap">
          <li className="c__tag-view">블록체인</li>
          <li className="c__tag-view">환경</li>
        </ul>
        <ul className="product-group">
          <li className="product-img">
            <img src={darkLogoImg} alt="서비스소개이미지" />
          </li>
        </ul>
      </div> */}
		</li>
	);
};

export default ServiceIntro;
